/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell.�*/
export function getNoRowsLabel(
  searchText: string,
  filteringEnabled: boolean,
  isLoading?: boolean
) {
  let message = "No data is available";
  if (isLoading) {
    return undefined;
  }
  if (searchText !== "" && filteringEnabled) {
    message += " for the searched text and filter values";
  } else if (searchText !== "") {
    message += " for the searched text";
  } else if (filteringEnabled) {
    message += " for the filtered values";
  }
  return message;
}
